import React,{ forwardRef, useEffect, useState, useRef } from "react";
import { message } from "antd";
import useEditorStore from "@/store/useEditorStore";


const EventLayer = forwardRef(({children},ref) =>{
    const moveNewLink = useEditorStore.use.moveNewLink();
    const outer = useEditorStore.use.outer();
    const clearNewLink = useEditorStore.use.clearNewLink();
    const removeSelected = useEditorStore.use.removeSelected();
    const setSelectedNode = useEditorStore.use.setSelectedNode();
    const setSelectedLine = useEditorStore.use.setSelectedLine();
    const mouseOnNode = useEditorStore.use.mouseOnNode();
    const opMode = useEditorStore.use.op_mode();
    const setOpMode = useEditorStore.use.setOpMode();
    const AddLink = useEditorStore.use.AddLink();
    const moveNode = useEditorStore.use.moveNode();
    const setLassoStart = useEditorStore.use.setLassoStart();
    const lassoStart = useEditorStore.use.lassoStart();
    const setLassoEnd = useEditorStore.use.setLassoEnd();
    const updateMovingSet = useEditorStore.use.updateMovingSet();
    const copySelected = useEditorStore.use.copySelected();
    const pasteSelected = useEditorStore.use.pasteSelected();
    const setMousePt = useEditorStore.use.setMousePt();

    const handleKeyDown = (event) => {
        if (event.keyCode === 46) { // Delete键的键码
          console.log('Delete key pressed');
          //删除节点
          removeSelected();
          // 执行删除操作
        }
        if (event.ctrlKey || event.metaKey) {
            switch (event.key) {
                case 'c':
                    // 执行复制操作
                    message.success("复制");
                    copySelected();
                    break;
                case 'v':
                    // 执行粘贴操作
                    message.success("粘贴");
                    pasteSelected();
                    break;
                default:
                    break;
            }
        }
      };

    useEffect(() => {
        const wrappedHandleKeyDown = (event) => {
            // 检查事件的目标是否在Form表单内
            if (!event.target.closest('form')) {
                handleKeyDown(event);
            }
        };

        window.addEventListener('keydown', wrappedHandleKeyDown);
        return () => {
          window.removeEventListener('keydown', wrappedHandleKeyDown);
        };
      }, [handleKeyDown]);

    return (<g ref={ref}
        onMouseDown={(e)=>{
            e.preventDefault();
            e.stopPropagation();
            // 获取SVG元素的屏幕转换矩阵
            if(outer == null) return;
            setOpMode(3);
            //if (opMode === 3) {
                // Start lasso selection
                const pt = getSVGMousePosition(e, outer);
                setLassoStart(pt);
                setLassoEnd(pt);
            //}
        }}
        onMouseMove={(e) => {
        e.preventDefault();
        //判断移动的数据
        // 获取SVG元素的屏幕转换矩阵
        if(outer == null) return;
        // 转换鼠标坐标到SVG内部坐标
        const transformedPoint = getSVGMousePosition(e, outer);

        switch (opMode) {
            case 1:
                moveNewLink(transformedPoint.x, transformedPoint.y);
                break;
            case 2:
                moveNode(transformedPoint.x, transformedPoint.y);
                break;
            case 3:
                if (lassoStart) {
                    const pt = getSVGMousePosition(e, outer);
                    setLassoEnd(pt);
                }
                break;
            default:
                {
                const pt = getSVGMousePosition(e, outer);
                setMousePt(pt);
                break;
            }
        }
        //console.log(e);
    }} onMouseUp={(e)=>{
        //判断是什么操作状态
        // 状态： 连接两个node关系
        //        
        switch (opMode) {
            case 1:
                {
                    //判断是否在节点上
                    if (mouseOnNode != null) {
                        //直接添加关系
                        AddLink();
                    }
                    clearNewLink();
                    break;
                }
            case 2:
                {
                    //setSelectedNode(null);
                    setSelectedLine(null);
                    break;
                }
            case 3:
                // End lasso selection
                updateMovingSet();
                setLassoStart(null);
                setLassoEnd(null);
                setSelectedLine(null);
                setSelectedNode(null);
                break;
            default:
                {
                    setSelectedLine(null);
                    setSelectedNode(null);
                }
                break;
        }
        setOpMode(null);

    }} transform="scale(1)">{children}</g>);
});

// Helper function to get mouse position in SVG coordinates
function getSVGMousePosition(e, svg) {
    const matrix = svg.getScreenCTM();
    const pt = svg.createSVGPoint();
    pt.x = e.clientX;
    pt.y = e.clientY;
    return pt.matrixTransform(matrix.inverse());
}

export default EventLayer;